// extracted by mini-css-extract-plugin
export default {"popupInner":"TimeIsFlying__popupInner--B2A"};